export default __webpack_public_path__ + "static/sprite-2f58d9b821ecbe7f1f3829bb57c1a372.svg";